export enum DocumentStaticActionType {
  CopyLink = 'copy-link',
  Delete = 'delete',
  Download = 'download',
  Move = 'move',
  Rename = 'rename',
}
